import React from "react";
import "../resources/styles/modal.scss";
import { Button } from "@mui/material";

export const Modal = (props) => {
  const { open, close, nowMediaQuery } = props;

  return (
    <div
      className={
        "modal " +
        (open ? "openModal " : "") +
        (nowMediaQuery === "mobile" ? "mobile " : "")
      }
    >
      {open ? (
        <section>
          {/* <main > */}
          {props.children}
          <Button className="foot_close" onClick={close}>
            닫기
          </Button>
          {/* </main> */}
        </section>
      ) : null}
    </div>
  );
};
